export const toCurrencyWithSign = (
  value: string | number,
  decimalPlaces = 0,
  currency = 'AUD',
  numberFormat = 'en-AU'
) =>
  Number.isNaN(Number(value))
    ? ''
    : new Intl.NumberFormat(numberFormat, {
        style: 'currency',
        currency,
        minimumFractionDigits: Number(value) ? decimalPlaces : 0,
      }).format(Number(value));

export const toCurrency = (num: number) => num.toFixed(2);

export const TWO_DECIMAL_PLACES = 2;
